document.addEventListener('DOMContentLoaded', function () {
  // Function to create and initialize radio buttons based on the options in the select box
  function initializeRadioButtons() {
    const selectBox = document.getElementById('SortBy-mobile');
    const radioButtonsDiv = document.getElementById('radioButtons');

    if (!selectBox || !radioButtonsDiv) return;

    // Clear any existing radio buttons
    radioButtonsDiv.innerHTML = '';

    // Create radio buttons based on select box options
    Array.from(selectBox.options).forEach((option, index) => {
      const wrapperDiv = createRadioButton(option, index);
      radioButtonsDiv.appendChild(wrapperDiv);
    });
  }

  // Function to create a radio button with a corresponding label
  function createRadioButton(option, index) {
    const wrapperDiv = document.createElement('div');
    wrapperDiv.classList.add('radio-wrapper');

    const radioButton = document.createElement('input');
    radioButton.type = 'radio';
    radioButton.name = 'sort_by'; // Changed from 'options' to 'sort_by'
    radioButton.value = option.value;
    radioButton.id = `option_${index}`;
    radioButton.addEventListener('change', function () {
      updateSelectBox(this.value);
      // Trigger form change event for facets.js
      const form = this.closest('form');
      if (form) {
        const event = new Event('change', { bubbles: true });
        form.dispatchEvent(event);
      }
    });

    const label = document.createElement('label');
    label.textContent = option.textContent;
    label.setAttribute('for', `option_${index}`);

    wrapperDiv.appendChild(label);
    wrapperDiv.appendChild(radioButton);

    return wrapperDiv;
  }

  // Function to update the select box value when a radio button is selected
  function updateSelectBox(value) {
    const selectBox = document.getElementById('SortBy-mobile');
    if (selectBox) {
      selectBox.value = value;
      // Trigger change event on the select box to ensure facets.js picks it up
      const event = new Event('change', { bubbles: true });
      selectBox.dispatchEvent(event);
    }
  }

  // Function to toggle the visibility of sort options
  function toggleSortOptions() {
    const sortOptions = document.getElementById('sortOptions');
    const parentElement = sortLabel.parentNode;

    if (!sortOptions) return;

    const isHidden = window.getComputedStyle(sortOptions).display === 'none';
    sortOptions.style.display = isHidden ? 'block' : 'none';
    parentElement.classList.toggle('open', isHidden);
  }

  // Initialize radio buttons when the page loads
  initializeRadioButtons();

  // Add click event listener to the sort label to toggle sort options
  const sortLabel = document.getElementById('sortLabel');
  if (sortLabel) {
    sortLabel.addEventListener('click', toggleSortOptions);
  }

  // Ensure the select box itself triggers form changes
  const selectBox = document.getElementById('SortBy-mobile');
  if (selectBox) {
    selectBox.addEventListener('change', function () {
      // Trigger form change event for facets.js
      const form = this.closest('form');
      if (form) {
        const event = new Event('change', { bubbles: true });
        form.dispatchEvent(event);
      }
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  let facets_url = false;
  if (window.collection_handle) {
    facets_url = `/collections/${collection_handle}?view=collection-facets`;
  } else if (window.search_url) {
    facets_url = `${search_url}&view=search-facets`;
  }

  if (facets_url) {
    getItemsFacets(facets_url);
    updateFormWithUrlParams();
  }

  window.getItemsFacets = getItemsFacets;
  window.getActiveFacets = getActiveFacets;
  window.updateFormWithUrlParams = updateFormWithUrlParams;
});

function updateFormWithUrlParams() {
  const urlParams = new URLSearchParams(window.location.search);
  const sortBy = urlParams.get('sort_by');

  // Add sort_by to mobile form
  const facetForm = document.getElementById('FacetFiltersFormMobile');
  if (facetForm) {
    if (sortBy) {
      addHiddenInput(facetForm, 'sort_by', sortBy);
    }
  }

  // Set sort value in desktop sort form
  const desktopSortForm = document.getElementById('FacetSortForm');
  if (desktopSortForm && sortBy) {
    const sortSelect = desktopSortForm.querySelector('select[name="sort_by"]');
    if (sortSelect) sortSelect.value = sortBy;
  }

  // Set sort value in mobile sort form
  const mobileSortSelect = document.getElementById('SortBy-mobile');
  if (mobileSortSelect && sortBy) mobileSortSelect.value = sortBy;

  // Remove sort_by from the rest of the URL parameters
  urlParams.delete('sort_by');

  const sortForm = document.getElementById('FacetSortDrawerForm');
  if (sortForm) {
    clearHiddenInputs(sortForm);
    urlParams.forEach((value, key) => {
      addHiddenInput(sortForm, key, value);
    });
  }
}

function getItemsFacets(facets_url) {
  fetch(facets_url)
    .then((response) => response.json())
    .then((data) => {
      handleFacets(
        data,
        'filter.p.m.specifications.color',
        'color-facets',
        getColorDetails,
        'filter.p.m.specifications.color',
        createFacetLabel,
        '',
        checkedIcon
      );
      handleFacets(
        data,
        'filter.p.product_type',
        'product_type-facets',
        getProductType,
        'filter.p.product_type',
        createFacetLabel,
        '',
        checkboxIcon
      );
      handleFacets(
        data,
        'filter.p.m.specifications.band_material',
        'band_material-facets',
        getBandMaterial,
        'filter.p.m.specifications.band_material',
        createFacetLabel,
        '',
        checkboxIcon,
        sortNumeric
      );
      handleFacets(
        data,
        'filter.p.m.specifications.watch_water_rating',
        'watch_water_rating-facets',
        null,
        'filter.p.m.specifications.watch_water_rating',
        createFacetLabel,
        '',
        checkboxIcon,
        sortNumeric
      );
      handleFacets(
        data,
        'filter.p.m.specifications.watch_size_range_mm',
        'watch_size_range_mm-facets',
        getSizeLabel,
        'filter.p.m.specifications.watch_size_range_mm',
        createFacetLabel,
        '',
        null,
        sortNumeric
      );

      // Handle price ranges
      handlePriceFacets(data['filter.v.price']);
    })
    .catch((error) => console.error('Error fetching collection facets:', error));
}

function handleFacets(
  data,
  key,
  elementId,
  getDetailsFunc,
  inputName,
  createLabelFunc,
  valuePrefix = '',
  iconHtml = '',
  sortFunc = sortAlphabetic
) {
  const listElement = document.getElementById(elementId);
  if (data[key].length > 0 && data[key] && Array.isArray(data[key])) {
    listElement.innerHTML = '';
    const items = data[key].sort(sortFunc);

    items.forEach((item, index) => {
      const listItem = document.createElement('li');
      listItem.className = 'mobile-facets__item list-menu__item';

      const label = createLabelFunc(item, index, inputName, getDetailsFunc, valuePrefix, key);
      if (iconHtml) {
        label.insertAdjacentHTML('beforeend', iconHtml);
      }

      listItem.appendChild(label);
      listElement.appendChild(listItem);
    });

    const listItems = document.querySelectorAll(`li[facet-type="${key}"]`);
    listItems.forEach((item) => {
      item.style.display = 'block';
    });
  } else {
    const listItems = document.querySelectorAll(`li[facet-type="${key}"]`);
    listItems.forEach((item) => {
      item.remove();
    });
    const detailItems = document.querySelectorAll(`details[facet-type="${key}"]`);
    detailItems.forEach((item) => {
      item.remove();
    });
  }
}

function createFacetLabel(item, index, inputName, getDetailsFunc, valuePrefix = '', key) {
  const label = document.createElement('label');
  label.setAttribute('for', `Filter-${inputName}-mobile-${key}-${index}`);
  label.className = 'mobile-facets__label';

  const input = document.createElement('input');
  input.className = 'mobile-facets__checkbox';
  input.type = 'checkbox';
  input.name = inputName;
  input.value = `${valuePrefix}${item}`;
  input.id = `Filter-${inputName}-mobile-${key}-${index}`;
  label.appendChild(input);

  const spanHighlight = document.createElement('span');
  const spanLabel = document.createElement('span');
  spanLabel.className = 'mobile-facets__label';
  if (getDetailsFunc && inputName != 'filter.p.m.specifications.watch_size_range_mm') {
    const details = getDetailsFunc(item);
    if (details) {
      if (details.image) {
        spanHighlight.style.backgroundImage = `url(${details.image})`;
      } else {
        spanHighlight.style.backgroundColor = details.color;
      }
      spanHighlight.className = details.hasLightBackground
        ? `mobile-facets__highlight light-color`
        : `mobile-facets__highlight`;
      spanLabel.textContent = details.name;
    } else {
      spanHighlight.style.backgroundColor = item;
      spanHighlight.className = 'mobile-facets__highlight light-color';
      spanLabel.textContent = item.charAt(0).toUpperCase() + item.slice(1);
    }
  } else if (getDetailsFunc && inputName == 'filter.p.m.specifications.watch_size_range_mm') {
    const sizeLabel = getDetailsFunc(item);
    if (sizeLabel) {
      const sizeSpan = document.createElement('span');
      sizeSpan.className = `watch--size watch--size-${sizeLabel.toLowerCase()}`;
      sizeSpan.textContent = sizeLabel;
      label.appendChild(sizeSpan);
    }

    const iconSpan = document.createElement('span');
    iconSpan.className = 'watch--icon';
    iconSpan.innerHTML = getWatchSizeIcon(input.value);
    label.appendChild(iconSpan);
    spanLabel.textContent = item + 'mm';
  } else {
    spanLabel.textContent = item;
  }

  if (getSearchParams(input.name, input.value)) {
    input.checked = true;
    appendExistingRefinement(spanLabel.textContent);
  }

  label.appendChild(spanHighlight);
  label.appendChild(spanLabel);

  return label;
}

function sortAlphabetic(a, b) {
  return a.localeCompare(b, undefined, { sensitivity: 'base' });
}

function sortNumeric(a, b) {
  const aValue = parseInt(a);
  const bValue = parseInt(b);
  if (isNaN(aValue)) return 1;
  if (isNaN(bValue)) return -1;
  return aValue - bValue;
}

function getColorDetails(colorCode) {
  return colorsList[colorCode.toLowerCase()] || null;
}

function getSizeLabel(label) {
  for (const key in sizeMapping) {
    if (label.startsWith(key)) {
      return sizeMapping[key];
    }
  }
  return null;
}

function getWatchSizeIcon(label) {
  const labelWithoutColon = label.replace(':', '');
  // Retrieve the SVG template from the config
  let svgTemplate = watchSizeIcon.replace(/{{ label_without_colon }}/g, labelWithoutColon);

  return svgTemplate;
}

function getProductType(type) {
  const shortFilter = type.split('>')[1]?.trim().toLowerCase().replace(/-/g, '');
  if (productTypes.hasOwnProperty(shortFilter)) {
    return productTypes[shortFilter];
  } else {
    return {
      name: type.split('>')[1]?.trim(),
    };
  }
}

function getBandMaterial(band) {
  const shortFilter = band.toLowerCase().replace(/ \/ /g, '_').replace(/ /g, '_');
  if (bandMaterials.hasOwnProperty(shortFilter)) {
    return bandMaterials[shortFilter];
  } else {
    return {
      name: band,
    };
  }
}

function handlePriceFacets(prices) {
  if (prices) {
    const listItems = document.querySelectorAll(`li[facet-type="price"]`);
    listItems.forEach((item) => {
      item.style.display = 'block';
    });
  }

  const sortedPrices = prices.map(Number).sort((a, b) => a - b); // Sort and convert to numbers
  const priceRanges = [];
  let rangeStart = 0;
  let step = 50;

  sortedPrices.forEach((price) => {
    if (price <= 300) {
      step = 50;
    } else if (price <= 500) {
      step = 100;
    } else {
      step = 300;
    }

    // Adjust range end based on the current step
    let rangeEnd = rangeStart + step;

    // Ensure the price falls into a proper range
    while (price >= rangeEnd) {
      if (sortedPrices.some((p) => p >= rangeStart && p < rangeEnd)) {
        // Only create a range if there's a price within it
        priceRanges.push({ min: rangeStart, max: rangeEnd });
      }
      // Move to the next range
      rangeStart = rangeEnd;
      rangeEnd = rangeStart + step;
    }
  });

  // Handle the last range to ensure it stops at max price
  const maxPrice = Math.max(...sortedPrices);
  if (rangeStart < maxPrice) {
    priceRanges.push({ min: rangeStart, max: maxPrice });
  }

  const urlParams = new URLSearchParams(window.location.search);
  const urlPriceRange =
    urlParams.has('filter.v.price.gte') || urlParams.has('filter.v.price.lte')
      ? {
          // Convert from dollars to cents for comparison with price ranges
          min: Number(urlParams.get('filter.v.price.gte')) * 100,
          max: Number(urlParams.get('filter.v.price.lte')) * 100,
        }
      : null;

  const listElement = document.getElementById('price-facets');
  listElement.innerHTML = '';
  priceRanges.forEach((range, index) => {
    const listItem = document.createElement('li');
    listItem.className = 'mobile-facets__item list-menu__item';

    const label = createPriceFacetLabel(range, index, urlPriceRange);
    label.insertAdjacentHTML('beforeend', checkboxIcon); // Append the checkbox icon

    listItem.appendChild(label);
    listElement.appendChild(listItem);
  });

  // Create hidden inputs
  if (urlPriceRange) {
    const form = document.getElementById('FacetFiltersFormMobile');
    // Convert from cents to dollars for URL parameters
    addHiddenInput(form, 'filter.v.price.gte', urlPriceRange.min / 100);
    addHiddenInput(form, 'filter.v.price.lte', urlPriceRange.max / 100);
    // Convert from cents to dollars for display
    const minDollars = (urlPriceRange.min / 100).toFixed(0);
    const maxDollars = (urlPriceRange.max / 100).toFixed(0);
    appendExistingRefinement(`${currency_symbol}${minDollars} - ${currency_symbol}${maxDollars}`);
  }

  // Update hidden input fields when checkboxes are toggled
  document.querySelectorAll('.mobile-facets__checkbox').forEach((checkbox) => {
    checkbox.addEventListener('change', handleCheckboxChange);
  });
}

function createPriceFacetLabel(range, index, urlPriceRange) {
  const label = document.createElement('label');
  label.setAttribute('for', `Filter-price-range-mobile-${index}`);
  label.className = 'mobile-facets__label';

  // Create checkbox input
  const checkbox = document.createElement('input');
  checkbox.className = 'mobile-facets__checkbox price-facets__checkbox';
  checkbox.type = 'checkbox';
  checkbox.id = `Filter-price-range-mobile-${index}`;
  checkbox.dataset.gte = range.min; // Store min value in data attribute
  checkbox.dataset.lte = range.max; // Store max value in data attribute

  const spanLabel = document.createElement('span');
  spanLabel.className = 'mobile-facets__label';
  // Convert from cents to dollars for display
  const minDollars = (range.min / 100).toFixed(0);
  const maxDollars = (range.max / 100).toFixed(0);
  spanLabel.textContent = `${currency_symbol}${minDollars} - ${currency_symbol}${maxDollars}`;

  if (urlPriceRange && range.min >= urlPriceRange.min && range.max <= urlPriceRange.max) {
    checkbox.checked = true;
  }

  label.appendChild(checkbox);
  label.appendChild(spanLabel);

  return label;
}

// Handle checkbox state change and add/remove hidden inputs
function handleCheckboxChange(event) {
  const checkbox = event.target;
  const gte = checkbox.dataset.gte;
  const lte = checkbox.dataset.lte;

  const form = document.getElementById('FacetFiltersFormMobile');

  // If the checkbox is checked, add hidden input fields to the form
  if (gte || lte) {
    const checkedPriceCheckboxes = document.querySelectorAll('.price-facets__checkbox:checked');
    const gteValues = [...checkedPriceCheckboxes].map((checkbox) => checkbox.dataset.gte);
    const lteValues = [...checkedPriceCheckboxes].map((checkbox) => checkbox.dataset.lte);

    removeHiddenInput(form, 'filter.v.price.gte');
    removeHiddenInput(form, 'filter.v.price.lte');

    if (checkedPriceCheckboxes.length) {
      // Convert from cents to dollars for URL parameters
      const minValue = Math.min(...gteValues) / 100;
      const maxValue = Math.max(...lteValues) / 100;
      addHiddenInput(form, 'filter.v.price.gte', minValue);
      addHiddenInput(form, 'filter.v.price.lte', maxValue);
    }
  }
}

// Function to add hidden input field to the form
function addHiddenInput(form, name, value) {
  let input = form.querySelector(`input[name="${name}"][value="${value}"]`);
  if (!input) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }
}

// Function to remove hidden input field from the form
function removeHiddenInput(form, name, value) {
  const input = form.querySelector(`input[name="${name}"]${value ? `[value="${value}"]` : ''}`);
  if (input) {
    form.removeChild(input);
  }
}

// Function to clear all hidden inputs in a form
function clearHiddenInputs(form) {
  form.querySelectorAll('input[type="hidden"]').forEach((input) => {
    input.remove();
  });
}

function getSearchParams(name, value) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.has(name) && urlParams.getAll(name).includes(value);
}

function appendExistingRefinement(filterLabel) {
  const FacetFiltersPillsForm = document.getElementById('FacetFiltersPillsFormDiv');

  // Check if the element exists before trying to append to it
  if (!FacetFiltersPillsForm) {
    console.warn('FacetFiltersPillsFormDiv element not found in DOM');
    return;
  }

  const facetRemoveElement = document.createElement('facet-remove');
  const anchorElement = document.createElement('a');
  anchorElement.href = `javascript:void(0)`;
  anchorElement.className = 'active-facets__button active-facets__button--light';

  const spanElement = document.createElement('span');
  spanElement.className = 'active-facets__button-inner button button--tertiary';
  spanElement.textContent = filterLabel;

  anchorElement.appendChild(spanElement);
  facetRemoveElement.appendChild(anchorElement);
  FacetFiltersPillsForm.appendChild(facetRemoveElement);

  updateFacetsCountMessage();
}

function updateFacetsCountMessage() {
  const FacetFiltersPillsForm = document.getElementById('FacetFiltersPillsFormDiv');

  // Check if the element exists before trying to access its properties
  if (!FacetFiltersPillsForm) {
    console.warn('FacetFiltersPillsFormDiv element not found in DOM');
    return;
  }

  const pillsCount = FacetFiltersPillsForm.childElementCount; // Count the number of pills
  const facetsCountDiv = document.getElementById('facets_count');
  const facetsCountSpan = document.getElementById('mobile-facets_count');

  if (facetsCountDiv) {
    if (pillsCount === 0) {
      facetsCountDiv.textContent = translation.results_no_filters_selected;
      facetsCountSpan.textContent = translation.results_no_filters_selected;
    } else if (pillsCount === 1) {
      facetsCountDiv.textContent = pillsCount + ' ' + translation?.results_filter_selected;
      facetsCountSpan.textContent = pillsCount + ' ' + translation?.results_filter_selected;
    } else {
      facetsCountDiv.textContent = pillsCount + ' ' + translation?.results_filters_selected;
      facetsCountSpan.textContent = pillsCount + ' ' + translation?.results_filters_selected;
    }
  }

  const facetsCountSpanWrapper = document.getElementById('refinements-current-main');
  if (facetsCountSpanWrapper) {
    facetsCountSpanWrapper.style.display = pillsCount > 0 ? 'block' : 'none';
  }
}

function getActiveFacets() {
  const checkboxes = document.querySelectorAll('.mobile-facets__checkbox');
  const FacetFiltersPillsForm = document.getElementById('FacetFiltersPillsFormDiv');

  // Check if the element exists before trying to access its properties
  if (!FacetFiltersPillsForm) {
    console.warn('FacetFiltersPillsFormDiv element not found in DOM');
    return;
  }

  FacetFiltersPillsForm.innerHTML = '';

  let checkedCount = 0;
  checkboxes.forEach(function (checkbox) {
    if (checkbox.checked) {
      const label = checkbox.closest('label');
      const spanLabel = label.querySelector('.mobile-facets__label')?.textContent;
      appendExistingRefinement(spanLabel);
      checkedCount++;
    }
  });

  if (checkedCount === 0) {
    updateFacetsCountMessage();
  }
}
